import React, { Component } from 'react'
import PropTypes from 'prop-types'

import NoProfilePicIcon from '@components/icons/NoProfilePic'

class Avatar extends Component {
  constructor ( props ) {
    super( props )
    this.state = {
      errorLoadingImage: false
    }
  }

  render () {
    const { src, alt, className } = this.props
    const cantLoadImage = !src || this.state.errorLoadingImage
    if ( cantLoadImage ) {
      return <NoProfilePicIcon className={className} />
    }

    return (
      <div className='avatar'>
        <img
          className={className}
          src={`/uploads/${src}`}
          alt={alt}
          onError={() => this.setState( { errorLoadingImage: true } )}
        />
      </div>
    )
  }
}

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string
}

export default Avatar
